import categories from './categories'

export default {
  categories,
  welcome: `{0} welcome to  {1}`,
  upload: `file upload`,
  share: `My Share`,
  edit: `edit 1`,
  login_title: `Lenovo Box`,
  login_inputUsername: `please Input User name`,
  login_submit_text: `submit`,
  upload_progress_text: `Uploading {0} files ({1} files)...`,
  upload_complete_text: `{0} file transfer completed`,
  message_dynamic_create_folder: '{0} has created a new folder "{1}"',
  message_dynamic_upload_file: '{0} uploaded a file "{1}"',
  message_dynamic_upload_folder: '{0} uploaded a file "{1}"',
  message_dynamic_update_file: '{0} has updated a file "{1}"',
  message_dynamic_add_auth: '{0} in the folder "{1}" has granted you the "{2}" permission',
  message_dynamic_update_auth: '{0} in the folder "{1}" changes your permissions from "{2}" to "{3}"',
  message_dynamic_delete_auth: '{0} removes your permissions in the folder "{1}"',
  message_dynamic_add_auth_for_share_folder: '{0} in the shared folder "{1}" gives you the "{2}" permission',
  message_dynamic_update_auth_for_share_folder: '{0} in the shared folder "{1}" changes your permissions from "{2}" to "{3}"',
  message_dynamic_delete_auth_for_share_folder: '{0} has removed your permissions on the shared file / folder "{1}"',
  message_dynamic_hand_over_share_folder_self: 'Your shared file / folder {0} is handed over to {1} by the administrator',
  message_dynamic_hand_over_share_folder: 'Administrator hand over the {0}\'s shared file / folder {1} to you',
  message_dynamic_update_user_name: 'Administrator updates your name to {0}',
  message_dynamic_update_user_mail: 'Administrator updates your mailbox information to {0}',
  message_dynamic_update_user_phone: 'Administrator updates your cell phone number to {0}',
  message_dynamic_update_user_datacenter: 'Administrator has adjusted your personal local space to {0}',
  message_dynamic_open_user_space: 'Administrator has opened your personal local space, size {0}, and configured your data center to {1}',
  message_dynamic_update_user_space: 'Administrator has adjusted your personal local space to {0}',
  message_dynamic_close_user_space: 'Administrator has closed your personal local space',
  message_dynamic_open_user_cloud_space: 'Administrator has opened your personal cloud space, {0} in size',
  message_dynamic_update_user_cloud_space: 'Administrator has adjusted your personal cloud space to {0}',
  message_dynamic_close_user_cloud_space: 'Administrator has closed your personal cloud space',
  message_dynamic_open_enterprise_cloud_space: 'Administrators have opened enterprise cloud space',
  message_dynamic_update_enterprise_cloud_space: 'Administrators updated the enterprise cloud space',
  message_dynamic_close_enterprise_cloud_space: 'Administrators have shut down enterprise cloud space',
  message_dynamic_open_speed_limit: 'Administrator opened the speed limit for the client transport, upload the threshold of {0}, download the threshold of {1}',
  message_dynamic_update_upload_speed: 'Administrator adjusts your client upload speed limit to {0}',
  message_dynamic_update_download_speed: 'Administrator adjusts your client download speed limit to {0}',
  message_dynamic_close_speed_limit: 'Administrator has closed your client speed limit',
  message_comment_content: '{0} mentioned you in "{1}"'
}



// WEBPACK FOOTER //
// ./src/lang/en/index.js